import React from 'react';
import ConfirmationScreen from '../application/screens/Confirmation/ConfirmationScreen';

function Confirmation() {
  return (
    <>
      <ConfirmationScreen />
    </>
  );
}

export default Confirmation;
